import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Resident access banner',
    },
  },
};


export function ResidentAccessHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="residentaccesshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Resident access banner"
    >
      <InnerPageHeroSubtitle path="residentaccesshero.subtitle" />
      <RichTextContent
        path="residentaccesshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="residentaccesshero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="residentaccesshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ResidentAccessHero',
  displayName: 'Resident Access Hero',
  tokens: {
    'residentaccesshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Resident Access</p>',
    },
    'residentaccesshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Resident Portal at <span data-type="field-token" data-field="property_name"></span></p>',
    },
  },
  slotGroups: {
    'residentaccesshero.bg_image': bgImageDef,
  },
};

(ResidentAccessHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ResidentAccessHero;
